/** Identità della tipologia dal catalogo; non usare titolo o descrizione dell'annuncio. */
export interface PropertyTypeIdentity {
  id?: string | null;
  code?: string | number | null;
  name?: string | null;
}

// Catalogo live verificato il 3 novembre 2026; TER è il codice legacy della migrazione.
export const LAND_PROPERTY_TYPE_ID = '557f2690-9ca0-4faa-bb01-17a5c24649d5';

export const isLandPropertyType = (type: PropertyTypeIdentity | null | undefined): boolean => {
  if (!type) return false;
  const code = String(type.code ?? '').trim().toUpperCase();
  const name = String(type.name ?? '').trim().toLocaleLowerCase('it-IT');
  const id = String(type.id ?? '').trim().toLowerCase();
  return code === '19' || code === 'TER' || name === 'terreno' || id === LAND_PROPERTY_TYPE_ID;
};
